(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme-scripts"] && !Shopify.designMode) return;
  try {
    (() => {
  const closeHeaderMenus = (except) => {
    document.querySelectorAll('[data-dropdown]').forEach((dropdown) => {
      if (dropdown === except) return;
      dropdown.classList.remove('open');
      const trigger = dropdown.querySelector('[data-dropdown-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  };

  document.querySelectorAll('[data-site-header]').forEach((header) => {
    const dropdown = header.querySelector('[data-dropdown]');
    const dropdownTrigger = header.querySelector('[data-dropdown-trigger]');
    const menuTrigger = header.querySelector('[data-menu-trigger]');
    const mobileMenu = header.querySelector('[data-mobile-menu]');
    const searchDialog = header.querySelector('[data-search-dialog]');
    const searchOpen = header.querySelector('[data-search-open]');
    const searchClose = header.querySelector('[data-search-close]');

    if (dropdown && dropdownTrigger) {
      dropdownTrigger.addEventListener('click', (event) => {
        event.stopPropagation();
        const willOpen = !dropdown.classList.contains('open');
        closeHeaderMenus(dropdown);
        dropdown.classList.toggle('open', willOpen);
        dropdownTrigger.setAttribute('aria-expanded', String(willOpen));
      });
    }

    if (menuTrigger && mobileMenu) {
      menuTrigger.addEventListener('click', () => {
        const willOpen = !mobileMenu.classList.contains('open');
        closeHeaderMenus();
        mobileMenu.style.setProperty('--mobile-menu-top', `${Math.max(header.getBoundingClientRect().bottom, 0)}px`);
        mobileMenu.classList.toggle('open', willOpen);
        mobileMenu.setAttribute('aria-hidden', String(!willOpen));
        menuTrigger.setAttribute('aria-expanded', String(willOpen));
        document.body.classList.toggle('menu-open', willOpen);
      });
    }

    if (searchDialog && searchOpen) {
      searchOpen.addEventListener('click', () => {
        if (mobileMenu) mobileMenu.classList.remove('open');
        document.body.classList.remove('menu-open');
        searchDialog.showModal();
        searchDialog.classList.add('open');
        document.body.classList.add('search-open');
        const searchInput = searchDialog.querySelector('input[type="search"]');
        if (searchInput) searchInput.focus();
      });
    }

    const closeSearch = () => {
      if (!searchDialog || !searchDialog.open) return;
      searchDialog.close();
      searchDialog.classList.remove('open');
      document.body.classList.remove('search-open');
      if (searchOpen) searchOpen.focus();
    };

    if (searchClose) searchClose.addEventListener('click', closeSearch);
    if (searchDialog) {
      searchDialog.addEventListener('click', (event) => {
        if (event.target === searchDialog) closeSearch();
      });
      searchDialog.addEventListener('cancel', () => {
        searchDialog.classList.remove('open');
        document.body.classList.remove('search-open');
      });
    }
  });

  document.addEventListener('click', () => closeHeaderMenus());
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeHeaderMenus();
  });

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('.gallery-main img');
    if (!mainImage) return;
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        mainImage.src = button.dataset.fullUrl;
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.alt = button.dataset.fullAlt || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        button.setAttribute('aria-pressed', 'true');
      });
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((formRoot) => {
    const form = formRoot.querySelector('form');
    if (!form) return;
    const section = formRoot.closest('[data-product-section]');
    const variantInput = form.querySelector('[data-variant-input]');
    const variantButtons = [...form.querySelectorAll('[data-variant-button]')];
    const price = section?.querySelector('[data-product-price]');
    const gallery = section?.querySelector('[data-gallery]');
    const mainImage = gallery?.querySelector('.gallery-main img');
    const galleryThumbs = [...(gallery?.querySelectorAll('[data-gallery-thumb]') || [])];
    const button = form.querySelector('[data-add-to-cart]');
    if (!button || !variantInput || variantButtons.length === 0) return;
    const updateVariant = (variantButton) => {
      variantInput.value = variantButton.dataset.variantId;
      if (price && variantButton.dataset.price) price.textContent = variantButton.dataset.price;
      if (mainImage && variantButton.dataset.mediaUrl) {
        mainImage.src = variantButton.dataset.mediaUrl;
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.alt = variantButton.dataset.mediaAlt || '';
        galleryThumbs.forEach((item) => {
          item.setAttribute('aria-pressed', String(item.dataset.mediaId === variantButton.dataset.mediaId));
        });
      }
      const available = variantButton.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? button.dataset.addText : button.dataset.soldText;
    };
    variantButtons.forEach((variantButton) => {
      variantButton.addEventListener('click', () => {
        variantButtons.forEach((item) => item.setAttribute('aria-pressed', 'false'));
        variantButton.setAttribute('aria-pressed', 'true');
        updateVariant(variantButton);
      });
    });
    const initialVariant = variantButtons.find((item) => item.getAttribute('aria-pressed') === 'true');
    if (initialVariant) updateVariant(initialVariant);
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });

  document.querySelectorAll('[data-quantity-control]').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    if (!input) return;
    const cartForm = control.closest('[data-cart-form]');
    let updateTimer;
    const submitCartUpdate = () => {
      if (!cartForm) return;
      window.clearTimeout(updateTimer);
      updateTimer = window.setTimeout(() => cartForm.requestSubmit(), 250);
    };
    control.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      input.stepDown();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    control.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      input.stepUp();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    input.addEventListener('change', submitCartUpdate);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
